import { ButtonV2 } from '@labrav/react-components'
import { FooterV2 } from '../../../../common/components/FooterV2/FooterV2'
import { useStyles } from '../ResellerAuthorizationCreation.styles'
import type { ResellerAuthorizationCreationFooterProps } from '../../types'

export const ResellerAuthorizationCreationFooter = ({
  footerWidth,
  handleSaveAsDraft,
  handleSubmit,
  loadingSaveAsDraft,
  offerSubmitloading,
  disableSaveAsDraft,
}: ResellerAuthorizationCreationFooterProps) => {
  const { classes } = useStyles()
  return (
    <FooterV2
      actions={
        <div
          className={classes.footerWrapper}
          data-testid="reseller-authorization-creation-footer"
        >
          <ButtonV2
            styleType="outlined"
            onClick={() => handleSaveAsDraft({ saveAsDraft: true })}
            data-testid={'save-as-draft'}
            loading={loadingSaveAsDraft}
            disabled={disableSaveAsDraft}
          >
            Save as draft
          </ButtonV2>
          <ButtonV2
            data-testid="save-button-private-offer"
            styleType="primary"
            onClick={handleSubmit}
            loading={offerSubmitloading}
          >
            Send to reseller
          </ButtonV2>
        </div>
      }
      width={footerWidth}
      customClass={classes.customFooter}
    />
  )
}
